/**
 * Grouped-thousands number formatting: 1234567 -> "1,234,567".
 *
 * The counterpart to `formatCompactNumber`, which trades exactness for width
 * ("1.23M"). Use this where the reader is meant to read the actual number —
 * a usage meter, a billing count, a table cell — and the compact form where
 * the number is a rough magnitude in a tight space.
 *
 * Locale is the viewer's browser locale, which is what every call site used
 * before this function existed. See `format-date.ts` for the same decision
 * about dates.
 */
export function formatNumber(value: number): string {
  if (!Number.isFinite(value)) {
    return value.toString();
  }
  return value.toLocaleString();
}
